module.exports = {"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-room-green.json
// module id = 275
// module chunks = 60335399758886 126609682503911